import * as t from "io-ts";
import { FinanceProvider } from "./FinanceProvider";
import { FinanceType } from "./FinanceType";
import { WorkType } from "./WorkType";

export const FinanceRate = t.intersection([
  t.type({
    name: t.string,
    fee: t.number,
    charge: t.number,
    enabled: t.boolean,
    finance_types: t.array(FinanceType),
    provider: FinanceProvider,
  }),
  t.partial({
    credit_line: t.number,
    min_charge: t.number,
    apr_type: t.union([
      t.literal("INTEREST_FREE"),
      t.literal("INTEREST_BEARING"),
      t.literal("BUYNOW_PAYLATER"),
    ]),
    apr: t.number,
    deferred_duration: t.number,
    duration: t.number,
    min_deposit_pct: t.number,
    max_deposit_pct: t.number,
    min_deposit_value: t.number,
    max_deposit_value: t.number,
    min_job_value: t.number,
    max_job_value: t.number,
    work_types: t.array(WorkType),
  }),
]);

export interface FinanceRate {
  name: string;
  credit_line?: number;
  fee: number;
  charge: number;
  min_charge?: number;
  enabled: boolean;
  finance_types: Array<FinanceType>;
  provider: FinanceProvider;
  apr_type?: "INTEREST_FREE" | "INTEREST_BEARING" | "BUYNOW_PAYLATER";
  apr?: number;
  deferred_duration?: number;
  duration?: number;
  min_deposit_pct?: number;
  max_deposit_pct?: number;
  min_deposit_value?: number;
  max_deposit_value?: number;
  min_job_value?: number;
  max_job_value?: number;
  work_types?: Array<WorkType>;
}
